@if (channels | async; as channels$) { @if (selectedChannels | async; as
selection$) {
<div class="channel-management">
  <div class="channel-management__list">
    @for (channel of channels$; track channel.id) {
    <div
      class="organizational-container"
      [ngClass]="{
        'organizational-container--selected': isSelected(selection$, channel)
      }"
      (click)="selectChannel(channel)"
      (keyup.enter)="selectChannel(channel)"
      tabindex="0"
    >
      <div class="organizational-container__title">
        <strong [innerText]="channel.displayName"></strong>
      </div>
      <div class="organizational-container__info">
        <div class="container">
          @if (channel.info.url) {
          <div class="color-muted" [innerText]="channel.info.url"></div>
          } @if (channel.info.address) {
          <div class="color-muted" [innerText]="channel.info.address"></div>
          }
        </div>
      </div>
    </div>
    }
  </div>
  <div class="channel-management__content">
    @if (selection$.length) {
    <tertiary-menu-bar></tertiary-menu-bar>
    <tswp-route-content></tswp-route-content>
    } @else {
    <div class="channel-management__empty">
      <div>
        <h1
          [translate]="
            'carrier.channel-management.no-channel-selected-headline'
          "
        ></h1>
      </div>
      <div>
        <div
          class="color-muted"
          [translate]="'carrier.channel-management.no-channel-selected-text'"
        ></div>
      </div>
    </div>
    }
  </div>
</div>
} }
